<template>
  <v-container fluid class="pt-3">
    <v-layout row wrap class="control">
      <v-flex xs12 md12 class="text-center">
        <div class="pb-3">
          <el-select
            v-model="form.shop_id"
            filterable
            placeholder="เลือกร้านค้า"
            :size="`small`"
            class="pr-2"
          >
            <el-option
              v-for="item in shopList"
              :key="item.shop_id"
              :label="item.name"
              :value="item.shop_id"
            ></el-option>
          </el-select>

          <el-date-picker
            size="small"
            v-model="daterange"
            type="daterange"
            value-format="yyyy-MM-dd"
            format="dd/MM/yyyy"
            range-separator="To"
            start-placeholder="Start date"
            end-placeholder="End date"
          ></el-date-picker>
          <el-button
            type="primary"
            :disabled="isLoading"
            class="ml-2"
            size="mini"
            @click="viewReport"
            >ค้นหา</el-button
          >
        </div>
      </v-flex>
    </v-layout>
    <el-card class="mt-3">
      <div slot="header" class="clearfix">
        <span>&nbsp;</span>
        <el-button
          icon="fas fa-file-download"
          v-if="items.length > 0"
          style="float: right; padding: 3px 0"
          type="text"
          @click="downloadReport"
          >&nbsp;ดาวน์โหลด</el-button
        >
      </div>
      <v-data-table
        :headers="headers"
        :items="items"
        :loading="isLoading"
        :page.sync="page"
        :items-per-page="itemsPerPage"
        :mobile-breakpoint="`10`"
        @page-count="pageCount = $event"
        hide-default-footer
      >
        <template v-slot:item.product_id="{ item }">{{
          item.product_id
        }}</template>
        <template v-slot:item.name="{ item }">{{ item.name }}</template>
        <template v-slot:item.quantity="{ item }">{{
          item.quantity | numFormat("0,0.00")
        }}</template>
        <template v-slot:item.amount="{ item }">{{
          item.amount | numFormat("0,0.00")
        }}</template>
      </v-data-table>
    </el-card>
    <div
      style="position:fixed; bottom:10px; right:10px; z-index:9; width:100%;"
    >
      <v-pagination
        circle
        v-model="page"
        :total-visible="5"
        :length="pageCount"
      ></v-pagination>
    </div>
  </v-container>
</template>

<script>
import Service from "../../services";

import moment from "moment";
export default {
  components: {},
  data() {
    return {
      isLoading: true,
      daterange: [moment().format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")],
      form: {
        shop_id: "",
      },
      headers: [
        {
          text: "#",
          align: "left",
          sortable: false,
          value: "product_id",
        },
        { text: "ชื่อสินค้า", value: "name" },
        { text: "จำนวนการขาย", value: "count" },
        // { text: "ยอดขาย", align: "right", value: "amount" },
        { text: "ต้นทุน", align: "right", value: "cost" },
      ],
      shopList: [],
      items: [],
      page: 1,
      itemsPerPage: 25,
      pageCount: 0,
    };
  },
  created() {
    Service.Shop.gets().then((res) => {
      if (res.success) {
        this.shopList = res.data.map((item) => {
          return {
            shop_id: item.shop_id,
            name: item.name,
            status: item.status,
          };
        });

        this.shopList = this.shopList.filter(function(item) {
          return item.status == "published";
        });

        this.isLoading = false;
      }
    });
  },
  methods: {
    viewReport() {
      let data = {
        begin: this.daterange[0],
        end: this.daterange[1],
        shop_id: this.form.shop_id,
      };

      Service.Report.logbook(data).then((res) => {
        this.items = res.data;
        // let arr = [];
        // res.data.map((item) => {
        //   arr = arr.concat(item.product_list_json);
        // });

        // var groups = arr.reduce(function(obj, item) {
        //   obj[item.product_id] = obj[item.product_id] || [];
        //   obj[item.product_id].push({
        //     product_id: item.product_id,
        //     ...item,
        //   });
        //   return obj;
        // }, {});

        // var myArray = Object;
        // myArray = Object.keys(groups).map((key) => {
        //   let menus = groups[key];
        //   let quantity = 0;
        //   let regular_price = 0;
        //   groups[key].map((g) => {
        //     quantity = quantity + g.quantity;
        //     regular_price = regular_price + g.quantity * g.regular_price;
        //   });
        //   return {
        //     product_id: key,
        //     name: groups[key][0].name,
        //     quantity: quantity,
        //     regular_price: regular_price,
        //     cost: 0,
        //   };
        // });
        // this.items = myArray;
      });
    },
    downloadReport() {
      let params = {
        begin: this.daterange[0],
        end: this.daterange[1],
        shop_id: this.form.shop_id,
        type: "download",
        report: true,
      };

      if (this.selectedShopId != null) {
        params.shop_id = this.selectedShopId;
      }

      var queryString = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");

      let vuex = JSON.parse(localStorage.getItem("pro-halalize"));
      let accessToken = vuex.Auth.accessToken;

      var request = new XMLHttpRequest();

      request.responseType = "blob";
      request.onreadystatechange = (e) => {
        let _ = this;
        let filename = "รายการทั้งหมด_";
        if (this.selectedShopId != null) {
          let filename = _.shopList.find((x) => x.shop_id == _.selectedShopId)
            .name;
        }
        if (request.readyState !== 4) {
          return;
        }
        if (request.status === 200) {
          //console.log("success", request.response);
          var fileURL = window.URL.createObjectURL(
            new Blob([request.response], {
              type: "application/vnd.ms-excel",
            })
          );
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", "inventory_" + filename + ".csv");
          document.body.appendChild(fileLink);

          fileLink.click();
        } else {
          console.warn(request);
        }
      };

      request.onload = function(oEvent) {
        var blob = request.response;
      };

      request.open(
        "POST",
        "https://hlzd-delivery-api.halalize.com/console/report/logbook"
      );
      request.setRequestHeader("Content-Type", "application/json");
      request.setRequestHeader("Authorization", "Bearer " + accessToken);

      request.send(JSON.stringify(params));
    },
  },
};
</script>
